import axios from 'axios';

export default {
  select: (state, data) => {
    axios.defaults.headers.common['X-Shop-Id'] = data.url;
    state.selected = data;
  },
};
